import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { isHighlighted, isSuperHighlighted, isHighlightedGold, isHighlightedSilver } from "../../../Utils/Functions";
import { HighlightedIconSilver } from "shared-components/Components/CustomIcons/HighlightedIconSilver"
import { HighlightedIconGold } from "shared-components/Components/CustomIcons/HighlightedIconGold"
import { HighlightedIconBlack } from "shared-components/Components/CustomIcons/HighlightedIconBlack"
import { ProjectIcon } from "shared-components/Components/CustomIcons/ProjectIcon/web"
import { ProductTagIcon } from "shared-components/Components/CustomIcons/ProductTagIcon"
import { useTheme } from "shared-components/Styles/ThemeHook"

import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { useContext } from "react";

export const FRAGMENT_LISTINGTYPETAG = new FragmentDefiner(
	"Property",
	`
    project {
        id
	}
	isExternal
    highlight
    created_at
    updated_at
	tags
`
);

export function UseListingTypeTag({ id }) {
    const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	const { loading, data, error } = useReadFragment(FRAGMENT_LISTINGTYPETAG, id);
	let tags = [];

	if (loading || error) return { loading, tags, error };

	if (data.project.length && country_code != "BR") {
		tags.push({ name: "isProject", text: null, icon: <ProjectIcon width={18} height={18} /> });
	}

	if (data.highlight) {
		if (isSuperHighlighted(data.highlight)) {
			tags.push({ name: "isSuperHighlighted", text: "Destacado", icon: <HighlightedIconBlack width={20} height={20} /> });
		} else if (isHighlighted(data.highlight) || isHighlightedGold(data.highlight)) {
			tags.push({ name: "isHighlightedGold", text: "Destacado", icon: <HighlightedIconGold width={20} height={20} /> });
		} else if (isHighlightedSilver(data.highlight)) {
			tags.push({ name: "isHighlightedSilver", text: "Destacado", icon: <HighlightedIconSilver width={20} height={20} /> });
		}
	}

	if (data.tags && !!data.tags.length) {
        data.tags.map((tag) => {
            tags.push({ name: `tag-${tag.tag_type}`, text: tag.tag_type, icon: <ProductTagIcon width={16} color={theme.colors.primaryColor} /> });
        })
    }

	if (data.isExternal) {
		tags.push({ name: "isExternal", text: "Ficha externa", icon: null });
	}

	return { loading, tags, error };
}
